import { Component, Inject, inject, OnInit, PLATFORM_ID } from '@angular/core';
import { UserDataService } from '../../shared/services/auth/userData.service';
import { ActivatedRoute, Router } from '@angular/router';
import { isPlatformBrowser } from '@angular/common';
import { SpinnerComponent } from '../components/spinner/spinner.component';

@Component({
  selector: 'app-building',
  standalone: true,
  imports: [
    SpinnerComponent
  ],
  templateUrl: './building.component.html',
  styleUrl: './building.component.css',
})
export class BuildingComponent implements OnInit {
  private readonly activatedRoute = inject(ActivatedRoute);
  buildingId: string | null = null;
  hasAssess: string = '0'; // Default to '0' (no assessment)
  userAssessPermission: string = '0'; // Default to '0' (no permission)
  regionId: string = '1'; // Default to '1' as Alabama, '2' is Mississippi

  constructor(
    @Inject(PLATFORM_ID) private platformId: object,
    private router: Router,
    private userDataService: UserDataService
  ) {}

  ngOnInit(): void {
    this.activatedRoute.paramMap.subscribe((params) => {
      this.buildingId = params.get('buildingId');
      this.hasAssess  = params.get('hasAssess') ?? '0'; // Default to '0' if null
      this.userAssessPermission = params.get('userAssessPermission') ?? '0'; // Default to '0' if null
      this.regionId = params.get('regionId') ?? '1'; // Default to '1' as Alabama if null

      if (this.buildingId) { // SSR
        this.userDataService.setBuildingId(this.buildingId); // set building Id from url
        this.router.navigate(['/']);
      }
      this.userDataService.setAssessStatus(this.hasAssess);
      this.userDataService.setUserAssessPermission(this.userAssessPermission);
      this.userDataService.setRegionId(this.regionId);
      
      if (isPlatformBrowser(this.platformId)) { // CSR
        if (this.buildingId) {
          localStorage.setItem("tip_building_id", this.buildingId); // set building Id in local storage
        }

        if (localStorage.getItem("tip_building_id")) { // get building Id from local storage
          this.buildingId = localStorage.getItem("tip_building_id");
          this.userDataService.setBuildingId(this.buildingId + ""); // set building Id from local storage
        }
      }
    });
  }
}
